import Accordion from 'components/common/Accordion/Accordion';
import ContainerHeader from 'components/common/ContainerHeader';
import React from 'react';
import styled from 'styled-components';
import {colors, containerStyles} from 'styles/shared';

const Container = styled.div`
  width: 54.4rem;
  height: 80.4rem;
  padding: 3.9rem 4.8rem 2rem 4.5rem;
  margin-bottom: 5rem;
  margin-right: 5rem;
  ${containerStyles};
`;

const Header = styled(ContainerHeader)`
  margin-bottom: 1rem;
`;

function BigComponent() {
  const items = [
    {id: 101, text: 'Can I search by countries and cities?', color: colors.blue_dark},
    {id: 102, text: 'Can I search by airports?', color: colors.green_main},
    {id: 103, text: 'Do you provide US data?', color: colors.yellow_main},
    {id: 104, text: 'Do you provide data for an itinerary with multiple trips?', color: colors.purple_main},
    {id: 105, text: 'Do you provide mask, certification and quarantine requirements?', color: colors.green_main},
    {id: 106, text: 'What other data do you provide?', color: colors.yellow_main},
    {id: 107, text: 'Where can I find more documentation?', color: colors.blue_dark},
    {id: 108, text: 'Do you pro-actively notify users of changes in the itinerary?', color: colors.green_main}
  ];

  function render() {
    return (
      <Container>
        <Header>Search</Header>

        <Accordion items={items} height={67} />
      </Container>
    );
  }

  return render();
}

export default BigComponent;
